/**
 * Hierarchy production/stage project
 */
export const yukka = [
  { label: 'Industry', type: 'hierarchy', id: 'industry' },
  { label: 'Country', type: 'hierarchy', id: 'country' },
  { label: 'Index', type: 'hierarchy', id: 'index' },
];

/**
 * Hierarchy develop project
 */
export const dev = [
  { label: 'Industry', type: 'hierarchy', id: 'industry' },
  { label: 'Country', type: 'hierarchy', id: 'country' },
  { label: 'Index', type: 'hierarchy', id: 'index' },
];

/**
 * Hierarchy iframe project
 */
export const iframe = [{ label: 'Industry', type: 'hierarchy', id: 'icb' }];
